import { Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router} from '@angular/router';
import { EstudioService} from '../../estudio.service';
import { Subscription} from 'rxjs';
import { RetroalimentacionService} from '../_services/retroalimentacion.service';

import * as moment from 'moment';
import { MatSnackBar} from '@angular/material/snack-bar';
import { CustomAlertService} from '../../../../_components/custom-alert/custom-alert.service';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MY_FORMATS} from '../../../../_models/moment-formats';
import { PdfPrintableComponent} from '../pdf-printable/pdf-printable.component';

moment.locale('es');


@Component({
  selector: 'retroalimentacion-lista-alumnos',
  standalone: false,
  templateUrl: 'retroalimentacion-lista-alumnos.component.html',
  styleUrls: ['../retroalimentacion.component.scss'],
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})

export class RetroalimentacionListaAlumnosComponent implements OnInit, OnDestroy {

  dataSub: Subscription;

  dataEvento: any;
  materiaActivaID: number;
  unidadID;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private matSnackBar: MatSnackBar,
              public matDialogRef: MatDialog,
              private estudioService: EstudioService,
              private retroalimentacionService: RetroalimentacionService,
              public customAlertService: CustomAlertService) {
  }

  ngOnInit() {
    this.unidadID = this.route.parent.snapshot.paramMap.get('id');
    this.materiaActivaID = +this.route.snapshot.paramMap.get('materiaID');

    this.route.params.subscribe(params => {
      this.dataSub = this.estudioService.getEventoDataRetroalimentacion(params['eventoUnidadID']).subscribe(res => {
        this.dataEvento = this.estudioService.extractData(res);
        if (this.materiaActivaID === 0) {
          this.materiaActivaID = this.dataEvento.materias[0].id;
        }
        this.dataEvento.materias.map(materia => {
          materia.fechas.map((fecha, i) => {
            materia.fechas[i] = moment(fecha).format('YYYY-MM-DD');
          });
          materia.alumnos.map(alumno => {
            alumno['checked'] = false; // Setear valor del back;
            alumno['showInput'] = false; // Setear valor del back;
            this.getUserImage(alumno);
          });
        });
      });
    });
  }

  ngOnDestroy() {
    if (this.dataSub) {
      this.dataSub.unsubscribe();
    }
  }

  setMateriaActivaID(materiaID) {
    this.materiaActivaID = materiaID;
    const alumnos = this.getAlumnos();
    alumnos.map(alumno => {
      alumno.checked = false;
    });
  }

  getAlumnos() {
    const materiaActiva = this.dataEvento.materias.find(materia => materia.id === this.materiaActivaID);
    return materiaActiva.alumnos;
  }

  getUserImage(alumno) {
    const objImg = new Image();
    objImg.src = alumno['imageUrl'];
    objImg.onload = function () {
      alumno['userImage'] = true;
    };
  }

  printButtonStatus() {
    const materiaActiva = this.dataEvento.materias.find(materia => materia.id === this.materiaActivaID);
    return materiaActiva.alumnos.filter(alumno => {
      return alumno.checked;
    }).length === 0;
  }

  pdfDataModal() {
    const materiaA = this.dataEvento.materias.find(materia => materia.id === this.materiaActivaID),
      alumnosChecked = this.getAlumnos().filter(alumno => alumno.checked);
    const dialogo = this.matDialogRef.open(PdfPrintableComponent, {
      width: '55%',
      disableClose: true,
      data: {
        alumnos: alumnosChecked,
        materia: materiaA,
        eventoId: +this.dataEvento.unidadEventoId
      }
    });

    const sub = dialogo.componentInstance.onPrint.subscribe(data => {
      this.pdfPrint(data, dialogo);
    });

    dialogo.afterClosed().subscribe(() => {
      sub.unsubscribe();
    });
  }

  pdfPrint(data, dialogo) {
    this.retroalimentacionService.pdfRetroalimentacion(data).subscribe(res => {
      const fileURL = URL.createObjectURL(res);
      dialogo.close();
      window.open(fileURL, '_blank');
    });
  }

  checkStatus(status) {
    this.getAlumnos().map(alumno => {
      if (+alumno.criteriosEvaluados !== 0) {
        alumno.checked = status;
      }
    });
  }

  compartirAlumnos(evt, materia) {
    const objReq = {
      fechaPublicarAlumno: moment(evt.value).format('YYYY-MM-DD'),
      materiaCursoPeriodoID: materia.id,
      unidadEventoID: this.dataEvento.unidadEventoId
    };

    this.retroalimentacionService.setFechaCompartir(objReq).subscribe(res => {
      this.matSnackBar.open('La fecha para compartir la evaluación ha sido asignada correctamente.',
        null,
        {duration: 2500});
    }, err => {
      materia.fechaPublicarAlumno = '';
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
      });
    });
  }

  deleteDate(materia) {
    this.retroalimentacionService.deleteFechaCompartir(this.dataEvento.unidadEventoId, materia.id).subscribe(res => {
      materia.fechaPublicarAlumno = '';
      this.matSnackBar.open('La fecha para compartir la evaluación ha sido eliminada correctamente.',
        null,
        {duration: 2500});
    }, err => {
      console.error('Nah', err);
    });
  }

  canDelete(materia) {
    let publicarDate = moment(materia.fechaPublicarAlumno),
      todayDate = moment();

    return publicarDate.isValid() && todayDate.isBefore(publicarDate);
  }

  evaluar() {
    let objetoEvento = {
        categoria: this.dataEvento.categoria,
        metas: this.dataEvento.metas,
        nombre: this.dataEvento.nombre,
        resumen: this.dataEvento.resumen,
        resumenTXT: this.dataEvento.resumenTXT,
        unidadEventoId: this.dataEvento.unidadEventoId,
        materias: [this.dataEvento.materias.find(materia => {
          return materia.id == this.materiaActivaID;
        })]
      },
      alumnosIDS = this.dataEvento.materias[0].alumnos.filter(alumno => {
        return alumno.checked;
      });

    this.retroalimentacionService.evento = objetoEvento;

    this.router.navigate(
      [
        {
          outlets: {
            retroalimentacion: [
              'evaluacion', this.dataEvento.unidadEventoId,
              'materia', this.materiaActivaID,
              'alumnos', alumnosIDS.toString()
            ]
          }
        }
      ],
      {relativeTo: this.route.parent});
  }

  retroalimentarAlumno(alumno) {
    alumno.checked = true;
    let objetoEvento = {
      categoria: this.dataEvento.categoria,
      metas: this.dataEvento.metas,
      nombre: this.dataEvento.nombre,
      resumen: this.dataEvento.resumen,
      resumenTXT: this.dataEvento.resumenTXT,
      unidadEventoId: this.dataEvento.unidadEventoId,
      materias: [this.dataEvento.materias.find(materia => {
        return materia.id == this.materiaActivaID;
      })]
    };
    this.retroalimentacionService.evento = objetoEvento;

    this.router.navigate([
        {
          outlets: {
            retroalimentacion: [
              'evaluacion', this.dataEvento.unidadEventoId,
              'materia', this.materiaActivaID,
              'alumnos', alumno.id]
          }
        }
      ],
      {
        relativeTo: this.route.parent
      }
    );
  }

  verEvaluacionAlumno(alumno) {
    if (alumno.criterios.length > 0) {
      alumno['evaluacion'] = [];
      let metas = Object.assign([], this.dataEvento.metas);
      metas.map(meta => {
        let currMeta = Object.assign({}, meta);
        currMeta.criterios = [];
        meta.criterios.map(criterio => {
          let currCriterio = Object.assign({}, criterio);
          currCriterio.niveles = [];
          criterio.niveles.map(nivel => {
            let currNivel = Object.assign({}, nivel);
            currNivel.criterios = [];
            nivel.criterios.map((criterioHijo, i) => {
              let currCritHijo = Object.assign({}, criterioHijo);
              currNivel.criterios.push(currCritHijo);
              if (alumno.criterios.find(criterioAl => {
                return criterioAl.criterioId == criterioHijo.id;
              })) {
                currNivel.criterios[i].isSeleccionado = true;
                let metaEvalInd = alumno.evaluacion.findIndex(metaEval => {
                  return metaEval.id == currMeta.id;
                });
                if (metaEvalInd > -1) {
                  let criterioEvalInd = alumno.evaluacion[metaEvalInd].criterios.findIndex(criterioEval => {
                    return criterioEval.id == currCriterio.id;
                  });
                  if (criterioEvalInd > -1) {
                    alumno.evaluacion[metaEvalInd].criterios[criterioEvalInd].niveles.push(currNivel);
                  } else {
                    currCriterio.niveles.push(currNivel);
                    alumno.evaluacion[metaEvalInd].criterios.push(currCriterio);
                  }
                } else {
                  currCriterio.niveles.push(currNivel);
                  currMeta.criterios.push(currCriterio);
                  alumno.evaluacion.push(currMeta);
                }
              }
            });
          });
        });
      });
    } else {
      alumno['evaluacion'] = null;
    }
  }
}
